import { CheckCircle2, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const SUPPORT_EMAIL = "support@shuwa.app";

// Shown once after sign-up: confirms the account exists and points to
// support if the confirmation email doesn't arrive.
export default function SignupConfirmationBanner() {
  const { signupConfirmation, setSignupConfirmation } = useAuth();

  if (!signupConfirmation) return null;

  return (
    <div role="status" className="border-b border-emerald-200 bg-emerald-50">
      <div className="mx-auto flex max-w-6xl items-start gap-3 px-4 py-3 text-sm text-emerald-900 sm:px-6">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" aria-hidden="true" />
        <p className="flex-1">
          <strong>Your SHUWA account has been created.</strong>{" "}
          {signupConfirmation.sent && signupConfirmation.email
            ? `We sent a confirmation to ${signupConfirmation.email}. `
            : ""}
          Didn't get it, or something looks wrong? Contact{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold underline">
            {SUPPORT_EMAIL}
          </a>
          .
        </p>
        <button
          type="button"
          onClick={() => setSignupConfirmation(null)}
          className="rounded p-1 text-emerald-700 hover:bg-emerald-100"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
